import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { BlogHero } from '../components/blog/BlogHero';
import { FeaturedPost } from '../components/blog/FeaturedPost';
import { BlogGrid } from '../components/blog/BlogGrid';
import { BlogNewsletter } from '../components/blog/BlogNewsletter';
import { BlogConsultCTA } from '../components/blog/BlogConsultCTA';
export function BlogPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2440">
      <Navigation data-id="element-2441" />
      <main data-id="element-2442">
        <BlogHero data-id="element-2443" />
        <FeaturedPost data-id="element-2444" />
        <BlogGrid data-id="element-2445" />
        <BlogNewsletter data-id="element-2446" />
        <BlogConsultCTA data-id="element-2447" />
      </main>
      <Footer data-id="element-2448" />
    </div>;
}